import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_BOTON_LISTAR_NUEVO, ESTILO_INPUT_GENERICO } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
import Select from "react-select";
import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import ModalTelefono from "../../components/modal-telefono";
import Spinner from "../../components/spinner";
import cargandoCard from "../../components/cargando-card";
import { COLOR_VERDE_MAIN } from "../../utils/const/colors-const";
import ModalEmail from "../../components/modal-email";
import moment from "moment";
import { actualizarAlmacen, crearAlmacen } from "../../api/api-almacen";

// let $ = window.$;
// let DevExpress = window.DevExpress;
// // console.log("DevExpress");
// // console.log(DevExpress);
// if (DevExpress?.ui?.themes) {
//   // console.log("DevExpress.ui está disponible");
//   DevExpress.ui.themes.current("light.compact");
// } else {
//   // console.warn("DevExpress.ui no está disponible");
// }

export default function AlmacenPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");


  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const markerRef = useRef(null);
  const formDataRef = useRef(null);
  // const telefonoHandlersRef = useRef({
  //   modificar: null,
  //   deshabilitar: null,
  //   habilitar: null,
  // });
  // const emailHandlersRef = useRef({
  //   modificar: null,
  //   deshabilitar: null,
  //   habilitar: null,
  // });

  const [requestSend, setRequestSend] = useState(false);

  // Keep formDataRef in sync with formData
  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    iniciar();
  }, []);

  useEffect(() => {
    if (!cargandoPage && formData && window.google && window.google.maps) {
      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        initializeMap();
      }, 100);
      return () => {
        clearTimeout(timer);
        // Cleanup marker on unmount
        if (markerRef.current) {
          markerRef.current.setMap(null);
          markerRef.current = null;
        }
      };
    }
    return () => {
      // Cleanup marker on unmount
      if (markerRef.current) {
        markerRef.current.setMap(null);
        markerRef.current = null;
      }
    };
  }, [cargandoPage, formData?.id]);

  // Update marker position when latitud/longitud inputs change manually
  useEffect(() => {
    if (map && formData?.latitud && formData?.longitud) {
      const lat = parseFloat(formData.latitud);
      const lng = parseFloat(formData.longitud);

      // Validate coordinates are numbers and within valid ranges
      if (!isNaN(lat) && !isNaN(lng) &&
        lat >= -90 && lat <= 90 &&
        lng >= -180 && lng <= 180) {
        const newLocation = new window.google.maps.LatLng(lat, lng);

        if (markerRef.current) {
          // Marker exists, update its position
          const currentPos = markerRef.current.getPosition();

          // Only update if the position is different (to avoid infinite loops)
          if (!currentPos ||
            Math.abs(currentPos.lat() - lat) > 0.000001 ||
            Math.abs(currentPos.lng() - lng) > 0.000001) {
            markerRef.current.setPosition(newLocation);
            map.setCenter(newLocation);
          }
        } else {
          // Marker doesn't exist, create one
          placeMarker(newLocation, map);
          map.setCenter(newLocation);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.latitud, formData?.longitud]);

  // Update marker color when color input changes
  useEffect(() => {
    if (markerRef.current && window.google && window.google.maps) {
      // Default to red if color is empty, invalid, or not provided
      let validColor = '#FF0000';

      if (formData?.color) {
        // Check if color is valid hex format
        if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(formData.color)) {
          validColor = formData.color;
        }
        // If invalid, keep default red
      }
      // If empty, keep default red

      // Update marker icon with the color (red if invalid/empty, or user's color if valid)
      const newIcon = getMarkerIcon(validColor);
      if (newIcon) {
        markerRef.current.setIcon(newIcon);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.color]);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const charLimits = {
    codigo: 64,
    descripcion: 512,
    nota: 1024,
    latitud: 16,
    longitud: 16,
    color: 7,
  };

  const applyScrollbarCSS = (gridElement) => {
    // Force scrollbars to always be visible on DevExtreme scrollable container
    setTimeout(() => {
      // Target the main scrollable container
      const scrollableContainer = gridElement.find('.dx-scrollable');
      if (scrollableContainer.length) {
        scrollableContainer.css({
          'overflow-x': 'scroll',
          'overflow-y': 'scroll'
        });
      }
      // Also target the scrollable content wrapper
      const scrollableContent = gridElement.find('.dx-scrollable-content');
      if (scrollableContent.length) {
        scrollableContent.parent().css({
          'overflow-x': 'scroll',
          'overflow-y': 'scroll'
        });
      }
      // Target the data grid's scrollable wrapper
      const dataGridScrollable = gridElement.find('.dx-datagrid-rowsview');
      if (dataGridScrollable.length) {
        dataGridScrollable.parent().css({
          'overflow-x': 'scroll',
          'overflow-y': 'scroll'
        });
      }
    }, 100);
  };

  const initializeMap = () => {
    if (!window.google || !window.google.maps) {
      console.warn('Google Maps API not loaded yet');
      return;
    }

    const mapElement = document.getElementById('mapa');
    if (!mapElement) {
      return;
    }

    // Clear any existing marker before initializing new map
    if (markerRef.current) {
      markerRef.current.setMap(null);
      markerRef.current = null;
    }

    // Get user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          // Initialize map centered on user location
          const googleMap = new window.google.maps.Map(mapElement, {
            center: userLocation,
            zoom: 15,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true,
          });

          setMap(googleMap);

          // If formData has existing coordinates, place marker there
          if (formData.latitud && formData.longitud) {
            const existingLocation = {
              lat: parseFloat(formData.latitud),
              lng: parseFloat(formData.longitud),
            };
            placeMarker(existingLocation, googleMap);
            googleMap.setCenter(existingLocation);
          }

          // Add click event listener to place marker
          googleMap.addListener('click', (event) => {
            const clickedLocation = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            };
            placeMarker(clickedLocation, googleMap);

            // Update form inputs - use functional update to preserve all fields including color
            setFormData(prev => ({
              ...prev,
              latitud: clickedLocation.lat.toFixed(6),
              longitud: clickedLocation.lng.toFixed(6),
            }));
          });
        },
        (error) => {
          console.error('Error getting user location:', error);
          // Default to Bolivia's center if geolocation fails
          const boliviaCenter = { lat: -16.5000, lng: -63.6000 };
          const googleMap = new window.google.maps.Map(mapElement, {
            center: boliviaCenter,
            zoom: 6,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true,
          });
          setMap(googleMap);

          // If formData has existing coordinates, place marker there
          if (formData.latitud && formData.longitud) {
            const existingLocation = {
              lat: parseFloat(formData.latitud),
              lng: parseFloat(formData.longitud),
            };
            placeMarker(existingLocation, googleMap);
            googleMap.setCenter(existingLocation);
          }

          // Add click event listener
          googleMap.addListener('click', (event) => {
            const clickedLocation = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            };
            placeMarker(clickedLocation, googleMap);

            // Update form inputs - use functional update to preserve all fields including color
            setFormData(prev => ({
              ...prev,
              latitud: clickedLocation.lat.toFixed(6),
              longitud: clickedLocation.lng.toFixed(6),
            }));
          });
        }
      );
    } else {
      // Fallback if geolocation is not supported - default to Bolivia
      const boliviaCenter = { lat: -16.5000, lng: -63.6000 };
      const googleMap = new window.google.maps.Map(mapElement, {
        center: boliviaCenter,
        zoom: 6,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
      });
      setMap(googleMap);

      // If formData has existing coordinates, place marker there
      if (formData.latitud && formData.longitud) {
        const existingLocation = {
          lat: parseFloat(formData.latitud),
          lng: parseFloat(formData.longitud),
        };
        placeMarker(existingLocation, googleMap);
        googleMap.setCenter(existingLocation);
      }

      googleMap.addListener('click', (event) => {
        const clickedLocation = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        placeMarker(clickedLocation, googleMap);

        // Update form inputs - use functional update to preserve all fields including color
        setFormData(prev => ({
          ...prev,
          latitud: clickedLocation.lat.toFixed(6),
          longitud: clickedLocation.lng.toFixed(6),
        }));
      });
    }
  };

  const getMarkerIcon = (color = '#FF0000') => {
    if (!window.google || !window.google.maps) {
      return null;
    }

    // Ensure color is valid hex format
    const validColor = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color) ? color : '#FF0000';

    // Create a custom SVG icon with the selected color
    const svgIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
        <path fill="${validColor}" stroke="#FFFFFF" stroke-width="2" d="M16 0C7.163 0 0 7.163 0 16c0 8.837 16 24 16 24s16-15.163 16-24C32 7.163 24.837 0 16 0z"/>
        <circle fill="#FFFFFF" cx="16" cy="16" r="6"/>
      </svg>
    `;

    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgIcon),
      scaledSize: new window.google.maps.Size(32, 40),
      anchor: new window.google.maps.Point(16, 40),
    };
  };

  const placeMarker = (location, mapInstance) => {
    // Remove existing marker if any (using ref for immediate access)
    if (markerRef.current) {
      markerRef.current.setMap(null);
      markerRef.current = null;
    }

    // Get color from current formDataRef (always latest value) or use default red if empty/invalid
    const currentFormData = formDataRef.current;
    let markerColor = '#FF0000'; // Default to red
    if (currentFormData?.color) {
      // Check if color is valid hex format
      if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(currentFormData.color)) {
        markerColor = currentFormData.color;
      }
      // If invalid, keep default red
    }
    // If empty, keep default red

    // Create new marker with custom colored icon
    const newMarker = new window.google.maps.Marker({
      position: location,
      map: mapInstance,
      draggable: true,
      animation: window.google.maps.Animation.DROP,
      icon: getMarkerIcon(markerColor),
    });

    // Update marker position when dragged
    newMarker.addListener('dragend', (event) => {
      const draggedLocation = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      // Use functional update to preserve all fields including color
      setFormData(prev => ({
        ...prev,
        latitud: draggedLocation.lat.toFixed(6),
        longitud: draggedLocation.lng.toFixed(6),
      }));
    });

    // Store marker in both ref and state
    markerRef.current = newMarker;
    setMarker(newMarker);
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleColorChange = (e) => {
    let { value } = e.target;

    // Allow empty string
    if (value === '') {
      setFormData({
        ...formData,
        color: value,
      });
      return;
    }

    // If it doesn't start with #, add it automatically
    if (!value.startsWith('#')) {
      value = '#' + value;
    }

    // Allow "#" followed by 0-6 hex characters (allows partial input while typing)
    const hexPart = value.substring(1);
    if (/^[A-Fa-f0-9]{0,6}$/.test(hexPart) && value.length <= 7) {
      setFormData({
        ...formData,
        color: value.toUpperCase(),
      });
    }
  };

  const handleColorPickerChange = (e) => {
    const { value } = e.target;
    // Color picker always returns valid hex format
    setFormData({
      ...formData,
      color: value.toUpperCase(),
    });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    setRequestSend(true);
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.latitud = formData.latitud;
    objEnviar.longitud = formData.longitud;
    objEnviar.color = formData.color;
    setProcessingVisible(true);
    try {
      if (formData.id === 0) {
        // console.log('crear correo');
        const response = await crearAlmacen(objEnviar);
        setProcessingVisible(false);
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (formData.id !== 0) {
        // console.log('actualizar correo');
        const response = await actualizarAlmacen(objEnviar);
        setProcessingVisible(false);
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (err) {
      console.log('handleSaveClick err');
      console.log(err);
      setProcessingVisible(false);
    } finally {
      setRequestSend(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            {/* lat lng */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                <>
                  <label
                    htmlFor="latitud"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t("label_latitud")}
                  </label>
                  <input
                    id="latitud"
                    name="latitud"
                    type="text"
                    value={formData.latitud}
                    onChange={handleInputChange}

                    className={ESTILO_INPUT_GENERICO}
                    required
                    maxLength={charLimits.latitud}
                    placeholder={t("placeholder_ingresa_latitud")}
                  />
                  <p className="text-sm text-gray-500 flex justify-end">{formData?.latitud?.length}/{charLimits.latitud}</p>
                  <label
                    htmlFor="longitud"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t("label_longitud")}
                  </label>
                  <input
                    id="longitud"
                    name="longitud"
                    type="text"
                    value={formData.longitud}
                    onChange={handleInputChange}

                    className={ESTILO_INPUT_GENERICO}
                    required
                    maxLength={charLimits.longitud}
                    placeholder={t("placeholder_ingresa_longitud")}
                  />
                  <p className="text-sm text-gray-500 flex justify-end">{formData?.longitud?.length}/{charLimits.longitud}</p>
                  <label
                    htmlFor="color"
                    className="block text-md font-medium text-gray-700 mb-2"
                  >
                    {t("label_color")}
                  </label>
                  <div className="flex gap-2 items-center">
                    <input
                      id="color"
                      name="color"
                      type="text"
                      value={formData.color || '#000000'}
                      onChange={handleColorChange}
                      className={ESTILO_INPUT_GENERICO}
                      placeholder="#FF00FF"
                      maxLength={7}
                    />
                    <input
                      type="color"
                      value={formData.color || '#000000'}
                      onChange={handleColorPickerChange}
                      className="h-10 w-16 cursor-pointer border border-gray-300 rounded"
                      title={t("label_seleccionar_color")}
                    />
                  </div>
                  <p className="text-sm text-gray-500 flex justify-end">{formData?.color?.length}/{charLimits.color}</p>
                  {formData.color && !/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(formData.color) && (
                    <p className="text-sm text-red-500 mt-1">
                      {t("alert_formato_color_invalido")}
                    </p>
                  )}
                </>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-8 xl:col-span-8">
                <label
                  htmlFor="mapa"
                  className="block text-md font-medium text-gray-700 mb-0"
                >
                  {t("label_mapa")}
                </label>
                <div
                  id="mapa"
                  className="w-full h-96 border border-gray-300 rounded-lg"
                  style={{ minHeight: '400px' }}
                ></div>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                  {requestSend === false && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      {t("label_aceptar")}
                    </button>
                  )}
                  {requestSend === true && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      disabled
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Spinner size="md" color="white" />
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
